import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    url: String,           // URL pour la recherche AJAX
    placeholder: String,
    maxItems: Number,
    minQueryLength: Number // Nombre minimum de caractères avant recherche (défaut: 2)
  }

  connect() {
    const maxItems = this.maxItemsValue || 1
    const minQueryLength = this.minQueryLengthValue || 2

    // Only use plugins for multi-select (maxItems > 1)
    const plugins = maxItems > 1 ? ['remove_button', 'clear_button'] : ['clear_button']

    const options = {
      plugins: plugins,
      persist: false,
      create: false,
      valueField: 'value',
      labelField: 'text',
      searchField: 'text',
      placeholder: this.placeholderValue || 'Tapez pour rechercher...',
      maxItems: maxItems,
      dropdownParent: 'body',
      loadThrottle: 300, // Attendre 300ms entre chaque requête
      load: (query, callback) => {
        // Ne rechercher que si assez de caractères
        if (!query || query.length < minQueryLength) {
          callback()
          return
        }

        // Utiliser & si l'URL contient déjà des paramètres, sinon ?
        const separator = this.urlValue.includes('?') ? '&' : '?'
        const url = `${this.urlValue}${separator}q=${encodeURIComponent(query)}`

        fetch(url, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            return response.json()
          })
          .then(data => {
            callback(data)
          })
          .catch(error => {
            console.error('TomSelect AJAX error:', error)
            callback()
          })
      },
      render: {
        no_results: function(data, escape) {
          const query = escape(data.input)
          if (query.length < minQueryLength) {
            return `<div class="no-results">Tapez au moins ${minQueryLength} caractères pour rechercher...</div>`
          }
          return `<div class="no-results">Aucun résultat pour "${query}"</div>`
        },
        loading: function(data, escape) {
          return '<div class="loading">Recherche en cours...</div>'
        }
      }
    }

    this.tomSelect = new TomSelect(this.element, options)

    // Assign to element.tomselect for external access
    this.element.tomselect = this.tomSelect

    // Listen to TomSelect's native 'change' event
    this.tomSelect.on('change', () => {
      this.element.dispatchEvent(new Event('change', { bubbles: true }))
    })

    // Dispatch custom event to notify that TomSelect is ready
    this.element.dispatchEvent(new CustomEvent('tomselect:ready', {
      bubbles: true,
      detail: { tomselect: this.tomSelect }
    }))
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
      this.tomSelect = null
    }
    if (this.element.tomselect) {
      this.element.tomselect = null
    }
  }
}
